import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.tripDelayStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.tripDelayStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelInterruption: {
    id: 'fastCover.tripDelayStep.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  travelDelay: {
    id: 'fastCover.tripDelayStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.tripDelayStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.tripDelayStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.tripDelayStep.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.tripDelayStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.tripDelayStep.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.tripDelayStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.tripDelayStep.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.tripDelayStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.tripDelayStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.tripDelayStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.tripDelayStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.tripDelayStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumber: {
    id: 'fastCover.tripDelayStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.tripDelayStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.tripDelayStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.tripDelayStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.tripDelayStep.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.tripDelayStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.tripDelayStep.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.tripDelayStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.tripDelayStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.tripDelayStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.tripDelayStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.tripDelayStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.tripDelayStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.tripDelayStep.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.tripDelayStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.tripDelayStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.tripDelayStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.tripDelayStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.tripDelayStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.tripDelayStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.tripDelayStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.tripDelayStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.tripDelayStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.tripDelayStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.tripDelayStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.tripDelayStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.tripDelayStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.tripDelayStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.tripDelayStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.tripDelayStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.tripDelayStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.tripDelayStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.tripDelayStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.tripDelayStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.tripDelayStep.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.tripDelayStep.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.tripDelayStep.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.tripDelayStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.tripDelayStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.tripDelayStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.tripDelayStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.tripDelayStep.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.tripDelayStep.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.tripDelayStep.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.tripDelayStep.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.tripDelayStep.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.tripDelayStep.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.tripDelayStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.tripDelayStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.tripDelayStep.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.tripDelayStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.tripDelayStep.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.tripDelayStep.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.tripDelayStep.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.tripDelayStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.tripDelayStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.tripDelayStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.tripDelayStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.tripDelayStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.tripDelayStep.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.tripDelayStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.tripDelayStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.tripDelayStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.tripDelayStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.tripDelayStep.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.tripDelayStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.tripDelayStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripDelayStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripDelayStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.tripDelayStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.tripDelayStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.tripDelayStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.tripDelayStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.tripDelayStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.tripDelayStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.tripDelayStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.tripDelayStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.tripDelayStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.tripDelayStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.tripDelayStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.tripDelayStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.tripDelayStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.tripDelayStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.tripDelayStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.tripDelayStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.tripDelayStep.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.tripDelayStep.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.tripDelayStep.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.tripDelayStep.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.tripDelayStep.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.tripDelayStep.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.tripDelayStep.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.tripDelayStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.tripDelayStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.tripDelayStep.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.tripDelayStep.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.tripDelayStep.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  schoolName: {
    id: 'fastCover.tripDelayStep.schoolName',
    defaultMessage: 'School Name',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.tripDelayStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.tripDelayStep.detailsRegardingYourTripDelay',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateDelayEnded: {
    id: 'fastCover.tripDelayStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },
  areYouClaimingForTripDelayPerDay: {
    id: 'fastCover.tripDelayStep.areYouClaimingForTripDelayPerDay',
    defaultMessage: 'Are you claiming for Trip Delay Per Day?',
  },
  areYouClaimingForKennelFeesAtHome: {
    id: 'fastCover.tripDelayStep.areYouClaimingForKennelFeesAtHome',
    defaultMessage: 'Are you claiming for Kennel Fees at Home?',
  },
  areYouClaimingForKennelFeesOnTrip: {
    id: 'fastCover.tripDelayStep.areYouClaimingForKennelFeesOnTrip',
    defaultMessage: 'Are you claiming for Kennel Fees on Trip?',
  },
  insureds: {
    id: 'fastCover.tripDelayStep.addInsured',
    defaultMessage: 'Name(s) and birthdates of all claimants:',
  },

  birthDay: {
    id: 'fastCover.tripDelayStep.birthDay',
    defaultMessage: 'Birth Day',
  },

  fullName: {
    id: 'fastCover.tripDelayStep.fullName',
    defaultMessage: 'Full Name',
  },

  addInsured: {
    id: 'fastCover.tripDelayStep.addInsured',
    defaultMessage: 'Add Insured',
  },

  insuredInformationWithIdx: {
    id: 'fastCover.tripDelayStep.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },

  dateOfLoss: {
    id: 'fastCover.tripDelayStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripDelayStep/messages.js